import {
  Box,
  ButtonGroup,
  IconButton,
  styled,
  Tab as MuiTab,
  Tabs as MuiTabs,
} from '@mui/material';
import {
  LOCATION_GROUP_CALENDAR_VIEW_HEADER_TAB_HEIGHT,
  LOCATION_HEADER_DAYPART_OFF_ALERT_HEIGHT,
  LOCATION_HEADER_HEIGHT,
} from 'src/constants';

export const Container = styled(Box)`
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
`;
export const CalendarContainer = styled(Box)(
  ({ $alertVisible }) => `
  width: 100%;
  height: calc(
    100% - ${LOCATION_HEADER_HEIGHT}px -
      ${LOCATION_GROUP_CALENDAR_VIEW_HEADER_TAB_HEIGHT}px - ${
    $alertVisible ? LOCATION_HEADER_DAYPART_OFF_ALERT_HEIGHT : 0
  }px
  );
  position: relative;

  & > div:first-of-type::-webkit-scrollbar {
    display: none;
  }
`,
);

export const HeaderContainer = styled(Box)`
  padding: 24px 0 48px 0;
  display: flex;
  justify-content: space-between;
`;

export const IconTextWrapper = styled(Box)`
  display: flex;
  justify-content: space-between;
`;

export const ButtonGroupWrapper = styled(ButtonGroup)(
  ({ theme }) =>
    `
    border: 1px solid ${theme.palette.primary.main};
    width: 136px;
    height: 36px;
    display: flex;
    overflow: hidden;
  `,
);
export const StyledIconButton = styled(IconButton)<{ $active?: boolean }>(
  ({ $active, theme }) => ({
    backgroundColor: $active
      ? theme.palette.primary.main
      : theme.palette.primary.lightest,
    color: $active
      ? theme.palette.primary.lightest
      : theme.palette.primary.main,
    borderRadius: 0,
    flex: 1,
    '&:hover': {
      backgroundColor: $active
        ? theme.palette.primary.main
        : theme.palette.primary.lightest,
    },
  }),
);

export const Tabs = styled(MuiTabs)(
  ({ theme }) => `
  border-bottom: 1px solid ${theme.palette.brand.charcoal};
`,
);

export const Tab = styled(MuiTab)(
  ({ theme }) => `
  &.Mui-selected {
    color: ${theme.palette.secondary.dark};
  }
`,
);
